<template>
  <input 
  class="moow-input-single"
  :id="id"
  :cols="cols"
  :rows="rows"
  :placeholder="placeholder" 
    v-bind:value="value"
    v-on:input="$emit('input', $event.target.value)"
  :autocomplete="{'on': autocomplete, 'off': !autocomplete}"
  :inputType="inputType"
  :class="getClasses()"/> 
</template>
<script>
// Example usage
//  <moow-input :type="['light', 'outlined', 'flat']" btnText="Testing" icon="edit"></moow-button>

export default {
  props: {
    id: {
        type: String, 
        required: true
    },   
    rows: {
        type: Number, 
        default: 1
    },  
    cols: {
        type: Number, 
        default: 50
    },  
    value: String,
    autocomplete: {
        type: Boolean,
        required: false
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputType: {
        type: String, 
        default: "text"
    },
    type: {
      type: Array,
      required: false,
    },
    camel: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false
    },
    autofocus: {
        type: Boolean,
        required: false
    }
  },
  components: {},
  data() {
    return {};
  },
  filters: {},
  computed: {
    listenerFunction() {
      return {
        ...this.$listener,
        input: this.updateValue
      };
    }
  },
  mounted() {},
  created() {
      this.setBehaviour()
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    setBehaviour(){
        document.getElementById(this.id).disabled = this.disabled;
        document.getElementById(this.id).autofocus = this.autofocus;
        document.getElementById(this.id).readonly = this.readonly;
    },
    handleClick(payload) {
      this.$emit("mClick", payload);
    },
    getClasses() {
      var valueHolder;
      valueHolder = "moow-input ";
      if (this.disabled) valueHolder += "m-disabled ";
      if(this.type){
        if (this.type.includes("light")) valueHolder += "m-light ";
        else if (this.type.includes("dark")) valueHolder += "m-dark ";
        else if (this.type.includes("blue")) valueHolder += "m-blue ";
        if (this.type.includes("fab")) valueHolder += "m-fab ";
        if (this.type.includes("outlined")) valueHolder += "m-outlined ";
        if (this.type.includes("flat")) valueHolder += "m-flat ";
        if (this.type.includes("wide")) valueHolder += "m-wide ";
        if (this.type.includes("link")) valueHolder += "m-link ";
        if (this.icon) valueHolder += "m-icon ";
      }

      
      if (this.trailingIcon) valueHolder += "flex-row-reverse";


      return valueHolder.trim();
    },
    format: function (value) {
      if (!value) return value;
      if (!this.camel) return value.toUpperCase();
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/variables.scss";

.moow-input {
    background: #F1F4F8;
    border-radius: 16px;
    border: none;
    width: 100%;
    padding: 1em;
    resize: none;
}

textarea:focus {
    outline: none !important;
    border:none;
}

textarea::-webkit-scrollbar {
  width: 5px;
}

/* Track */
textarea::-webkit-scrollbar-track {
  background: #f1f1f100;
}

/* Handle */
textarea::-webkit-scrollbar-thumb {
  background: #fea49f94;
  border-radius: 8px;
  cursor: pointer;
}

/* Handle on hover */
textarea::-webkit-scrollbar-thumb:hover {
  background: #fea49f;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/interface/input/moowInputSingle.vue